import React from 'react';
import { Table } from 'antd';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from './dictionary';
import './style.scss';

export default function CustomTable(props) {
	const country = props.country || Enviroment.COUNTRY;
	return (
		<>
			<Table {...props} className={Dictionary[country][props?.className]} />
		</>
	);
}
